<template>
 <!-- Contacts -->
      <div class="container g-py-40" id="contactDiv">
        <header class="text-center g-mb-50">
          <h1 class="h1">Contact Us</h1>
          <p class="g-font-size-20">Have a question or concern?  Please fill out the form below and we’ll get back to you soon.</p>
        </header>
        <jotform-embed jotFormID="220555106034141"></jotform-embed>
        <!--
        <div class="text-center mx-auto g-width-70x--md">
          <form>
            <div class="row">
              <div class="col-md-12 form-group g-mb-30">
                <input class="form-control g-color-gray-dark-v5 g-bg-white g-bg-white--focus g-brd-gray-light-v3 g-brd-primary--focus rounded-0 g-py-13 g-px-15" type="text" placeholder="Subject">
              </div>

              <div class="col-md-12 form-group g-mb-30">
                <textarea class="form-control g-color-gray-dark-v5 g-bg-white g-bg-white--focus g-brd-gray-light-v3 g-brd-primary--focus g-resize-none rounded-0 g-py-13 g-px-15" rows="7" placeholder="Type your questions or comments below"></textarea>
              </div>
            </div>

            <div class="text-center">
              <button class="btn u-btn-primary text-uppercase rounded-0 g-px-25 g-py-13" type="submit" role="button">Send Message</button>
            </div>
          </form>
        </div> -->
      </div>
      <!-- End Contacts -->
</template>
<script>
// import ContactForm from "@/components/portal/helpData/ContactForm";
import JotformEmbed from "@/components/shared/JotformEmbed"
export default {
  components: { JotformEmbed }
}
</script>



// WEBPACK FOOTER //
// HelpContact.vue?73744a36